<template>
     <vs-dialog v-model="active" @close="closeModal()" prevent-close>
        <template #header>
          <h4 class="not-margin">
            Devolución de pago
          </h4>
        </template>
        <div class="con-form">
          <vs-row>
            <vs-col vs-justify="center" vs-align="center" w="12" class="mb-2">
                <h6>{{row.concepto}}</h6>
                <label for="monto">Monto</label>
                <!-- <h6><strong>{{row.monto | currency}}</strong></h6> -->
                <vs-input
                  disabled
                  id="monto"
                  type="number"
                  v-model="monto"
                  class="pl-0 pt-0 pb-0"
                  style="width: 30% !important"
                />
                <p v-if="errorMonto == true" class="red pl-0 mb-0"><strong> Campo Requerido </strong></p>
            </vs-col>
            <vs-col w="12" class="mt-2">
                <md-field class="mb-0">
                  <label>Comentarios</label>
                  <md-textarea
                    v-model="comentarios"
                    id="comentarios"
                    name="comentarios">
                  </md-textarea>
                </md-field>
                  <p v-if="errorComentarios == true" class="red pl-0"><strong> Campo Requerido </strong></p>
            </vs-col>
          </vs-row>
        </div>
        <template #footer>
          <div class="footer-dialog" style="display:flex;">  
            <vs-button block danger class="color-red" @click="closeModal()">
              Cancelar
            </vs-button>
            <vs-button block success @click="getDevolucion()">
              Aceptar
            </vs-button>          
          </div>
        </template>
      </vs-dialog>
</template>

<script>
import profesor from '../../../../api/requests/landing-profesor.js'

export default {
    props:[
      'value',
      'row',
      'personaId',
      'cicloEscolar',
      'institucion',
    ],
    data () {
        return {
            active: false,
            monto: '',
            facturadosColores: {
                "Factura cancelada" : "red",
                "Sin factura" : "red",
                "Facturado": "green"
            },
            comentarios: null,
            errorMonto: false,
            errorComentarios: false
        }
    },
    methods: {
      async getDevolucion(){

            if(this.comentarios == null){
                this.errorComentarios = true
            }else{
                this.errorComentarios = false
            }

            if( this.comentarios == null){
                return false
            }
          try { 
            const loading = this.$vs.loading()
            const formData = new FormData();
            formData.append('pago', this.row.movimiento_id)
            formData.append('monto', this.monto)
            formData.append('comentarios', this.comentarios)
            const response = await profesor.getDevolucion(formData)
            loading.close()
            this.$emit('refreshTable')
            this.active = false
            this.comentarios = ''
          }
          catch{
            loading.close()
          }
      },
      closeModal(){
            this.comentarios = ''
            this.active = false
      },
      getFacturaColor(val){
          let classes = ''
          if (
              val 
              && this.facturadosColores[val] 
          ) {
              classes = 'col-'+this.facturadosColores[val]
          }
          return classes
      },
      getFacturaValue(value){
          return value.factura && value.factura.fecha_factura && value.factura.facturado == 'timbrado' ? 'Facturado' : value.factura.facturado == 'cancelado' ? 'Factura cancelada' : value.categoria != 'rebaja' ? 'Sin factura' : 'N/A'
      },
      async close () {
        this.active = false
      }
    },
    watch: {
        value (val) {
            this.active = val
        },
        active (val) {
            if (!val){
                this.$emit('input', val);
            }
        },
        row(){
          this.monto = this.row.abono
        }
    }
}
</script>

<style lang="scss"  scoped >
.color-blue {
  background-color: #005aa3;
}

.col-green{
  background: #b8d3bc;
  color:#55ce63;
}
.col-red{
  background: #f9e7eb;
  color:#f62d51;
}
.col-blue{
  color: #2874A6;
  background: rgb(214, 234, 248);
}
</style>